"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
var frame1 = {
  transform: "translate3d(0, 0, 0)"
};
var frame2 = {
  transform: "translate3d(-10px, 0, 0)"
};
var frame3 = {
  transform: "translate3d(10px, 0, 0)"
};
exports.default = {
  keyframes: [__assign(__assign({}, frame1), {
    offset: 0
  }), __assign(__assign({}, frame2), {
    offset: 0.1
  }), __assign(__assign({}, frame3), {
    offset: 0.2
  }), __assign(__assign({}, frame2), {
    offset: 0.3
  }), __assign(__assign({}, frame3), {
    offset: 0.4
  }), __assign(__assign({}, frame2), {
    offset: 0.5
  }), __assign(__assign({}, frame3), {
    offset: 0.6
  }), __assign(__assign({}, frame2), {
    offset: 0.7
  }), __assign(__assign({}, frame3), {
    offset: 0.8
  }), __assign(__assign({}, frame2), {
    offset: 0.9
  }), __assign(__assign({}, frame1), {
    offset: 1
  })],
  timing: {
    duration: 1000,
    fill: "both"
  }
};